export const GET_MENU_CATEGORIES = '[MENU APP] GET CATEGORIES';
export const SHOW_MENU_ITEM = '[MENU APP] SHOW ITEM';
export const HIDE_MENU_ITEM = '[MENU APP] HIDE ITEM';
export const SHOW_MENU_CATEGORY_ALERT = '[MENU APP] SHOW CATEGORY ALERT';
export const HIDE_MENU_CATEGORY_ALERT = '[MENU APP] HIDE CATEGORY ALERT';
export const SHOW_GIFT_ITEM = '[MENU APP] SHOW GIFT ITEM';
export const HIDE_GIFT_ITEM = '[MENU APP] HIDE GIFT ITEM';
export const SHOW_MENU_ALERT = '[MENU APP] SHOW ALERT';
export const HIDE_MENU_ALERT = '[MENU APP] HIDE ALERT';

export function setMenuCategories(categories) {
    return {
        type: GET_MENU_CATEGORIES,
        payload: categories
    }
}

export function showMenuItem(item) {
    return {
        type: SHOW_MENU_ITEM,
        payload: item
    }
}

export function hideMenuItem(item) {
    return {
        type: HIDE_MENU_ITEM
    }
}

export function showCategoryDisabledAlert(category) {
    return {
        type: SHOW_MENU_CATEGORY_ALERT,
        payload: category
    }
}

export function hideCategoryDisabledAlert() {
    return {
        type: HIDE_MENU_CATEGORY_ALERT
    }
}

export function showGiftItem(item,  gift) {
    return {
        type: SHOW_GIFT_ITEM,
        payload: {item, gift}
    }
}

export function hideGiftItem(item) {
    return {
        type: HIDE_GIFT_ITEM
    }
}

export function showMenuAlert(body) {
    return {
        type: SHOW_MENU_ALERT,
        payload: body
    }
}

export function hideMenuAlert() {
    return {
        type: HIDE_MENU_ALERT
    }
}